<script lang="ts">
  let { data } = $props();
</script>

<div class="flex flex-col gap-2 p-12 bg-primary-blue text-white rounded-2xl">
  {@html data.content}
</div>
